import axios, {AxiosResponse} from 'axios';

import {ExternalConditions, UpdateExternalConditions} from 'app/models';

const API_URL = process.env.REACT_APP_SHIPPING_API_URL;
const EXTERNAL_CONDITIONS_URL = `${API_URL}/v3/external-conditions`;

/** O modificador de condições externas em vigor (admin e membro da Mecanizou). */
export const getExternalConditions = async (): Promise<ExternalConditions> => {
  const response: AxiosResponse<ExternalConditions> = await axios.get(
    EXTERNAL_CONDITIONS_URL
  );
  return response.data;
};

/** Grava o modo escolhido e zera o outro; devolve o que ficou em vigor. */
export const updateExternalConditions = async (
  body: UpdateExternalConditions
): Promise<ExternalConditions> => {
  const response: AxiosResponse<ExternalConditions> = await axios.put(
    EXTERNAL_CONDITIONS_URL,
    body
  );
  return response.data;
};
